import React from 'react';
import { Row, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

export const TeamCoaches = React.forwardRef((props, ref) => {
  const { teamId } = props;
  const { teams } = useSelector((state) => state.admin);
  const team = teams.byId[teamId];

  const emptyList = () => {
    return (
      <Row
        style={{ minHeight: '40vh', textAlign: 'center' }}
        className="vCenter"
      >
        <span>No coaches assigned.</span>
      </Row>
    );
  };

  const setupBody = () => {
    if (team && team.coaches && team.coaches.items.length === 0) {
      return emptyList();
    } else {
      return emptyList();
    }
  };

  return (
    <Form onSubmit={null} className="teamCoaches">
      {setupBody()}
    </Form>
  );
});
